import { motion } from "framer-motion";
import { useI18n } from "../../i18n";

export default function Reviews() {
  const { t } = useI18n();
  return (
    <section className="py-24 md:py-36 lg:py-44 px-6 md:px-12 lg:px-20" data-testid="reviews-section">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-12 mb-14 md:mb-20">
          <div className="col-span-12 md:col-span-7">
            <span className="eyebrow">{t.reviews.eyebrow}</span>
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 1 }}
              className="font-serif-display text-4xl md:text-5xl lg:text-6xl text-charcoal mt-4 leading-tight"
              data-testid="reviews-title"
            >
              {t.reviews.title}
            </motion.h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-12 md:gap-y-20">
          {t.reviews.items.map((r, i) => (
            <motion.figure
              key={i}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.9, delay: (i % 2) * 0.1 }}
              className={`${i % 2 === 1 ? "md:mt-16" : ""}`}
              data-testid={`review-${i}`}
            >
              <blockquote className="font-serif text-3xl md:text-4xl lg:text-[2.6rem] leading-snug text-charcoal">
                <span className="text-charcoal/40">“</span>
                {r.quote}
                <span className="text-charcoal/40">”</span>
              </blockquote>
              <figcaption className="mt-6 flex items-center gap-4 text-xs tracking-luxe uppercase text-charcoal-mute">
                <span className="block w-8 h-px bg-charcoal/30" />
                <span>{r.author} · {r.from}</span>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
